import { render, staticRenderFns } from "./cart-form.vue?vue&type=template&id=2045bda2&"
import script from "./cart-form.vue?vue&type=script&lang=js&"
export * from "./cart-form.vue?vue&type=script&lang=js&"
import style0 from "./cart-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports